import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { createEnumGuard } from '#/utils/typeGuards'
import ar from '#locales/ar/translation.json'
import de from '#locales/de/translation.json'
import en from '#locales/en/translation.json'
import fr from '#locales/fr/translation.json'
import nl from '#locales/nl/translation.json'

export type TLocale = 'en' | 'nl' | 'de' | 'fr' | 'ar'
export const SUPPORTED_LOCALES: TLocale[] = ['en', 'nl', 'de', 'fr', 'ar']
export const RTL_LOCALES: TLocale[] = ['ar']

export const LOCALE_LABELS: Record<TLocale, string> = {
  en: 'English',
  nl: 'Nederlands',
  de: 'Deutsch',
  fr: 'Français',
  ar: 'العربية',
}

const resources = {
  en: { translation: en },
  nl: { translation: nl },
  de: { translation: de },
  fr: { translation: fr },
  ar: { translation: ar },
}

i18n
  // The languageDetector plugin makes sure to check `localStorage` first, if that does not contain a language setting
  // it falls back on the browsers default language. When the user changes the language it automatically stores this in
  // `localStorage`. See its repo for more info: https://github.com/i18next/i18next-browser-languageDetector.
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    compatibilityJSON: 'v4',
    initImmediate: true,
    resources,
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: 'en',
    debug: false,
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        platform: import.meta.env.REACT_APP_PLATFORM ?? 'WijMobiel',
        appName: 'WijMobiel app',
      },
    },
  })

const isRtlLocale = createEnumGuard(RTL_LOCALES)
const getDir = (lang: string): string => (isRtlLocale(lang) ? 'rtl' : 'ltr')

i18n.on('languageChanged', (lang) => {
  document.documentElement.setAttribute('lang', lang)
  document.documentElement.setAttribute('dir', getDir(lang))
})

document.documentElement.setAttribute('lang', i18n.language)
document.documentElement.setAttribute('dir', getDir(i18n.language))

export default i18n
